import _ from "lodash";
import { SidebarIcon } from "../components";
import { AttachmentIcon } from "../../../../assets/svg/AttachmentIcon";
import { evaluateFieldCondition } from "./formConditions";

// Helper function to create sidebar item
const createSidebarItem = (title, sectionName, validationFieldsBySidebarItem) => ({
  title,
  href: `#enrollment-form-${sectionName}`,
  key: _.camelCase(sectionName),
  icon: !sectionName.includes("attachments") ? SidebarIcon : AttachmentIcon,
  validationFields: validationFieldsBySidebarItem?.[sectionName] || [sectionName]
});

// A section is shown in the sidebar only when it is actually rendered in the form.
// This mirrors the section-level visibility check in renderReactFromJson so the
// sidebar and the form stay in sync (e.g. the Caregiver section is hidden for
// patients 18 or older). Without a form instance (string-based configs, tests)
// every section is kept.
const isSectionVisibleInSidebar = (section, form) => {
  const visibility = section.conditions?.visibility;
  if (!visibility || !form) {
    return true;
  }
  return evaluateFieldCondition(visibility, form);
};

// Generates sidebar config from array of strings (old structure)
const generateSidebarFromItems = (t, confRootPath, itemNamesArr, validationFieldsBySidebarItem) =>
  itemNamesArr.map((itemName) =>
    createSidebarItem(t(`${confRootPath}.${itemName}.sidebar`), itemName, validationFieldsBySidebarItem)
  );

// Generates sidebar config from array of objects (new JSON base structure)
const generateSidebarFromJson = (formSections, validationFieldsBySidebarItem, form) => {
  return formSections
    .filter((section) => isSectionVisibleInSidebar(section, form))
    .map(({ sectionSidebar, sectionName }) =>
      createSidebarItem(sectionSidebar, sectionName, validationFieldsBySidebarItem)
    );
};

export const SBItemsHelper = {
  generateSidebarConfig(
    t,
    confRootPath,
    {
      itemNamesArr = null,
      formSections = null,
      hasAdminOption = false,
      validationFieldsBySidebarItem = {},
      form = null
    }
  ) {
    let sidebarItems = [];

    if (Array.isArray(itemNamesArr)) {
      sidebarItems = generateSidebarFromItems(t, confRootPath, itemNamesArr, validationFieldsBySidebarItem);
    } else if (Array.isArray(formSections)) {
      sidebarItems = generateSidebarFromJson(formSections, validationFieldsBySidebarItem, form);
    }

    // Add admin option if required
    return hasAdminOption
      ? [
          createSidebarItem(
            t(`${confRootPath}.support_options.sidebar`),
            "support-options",
            validationFieldsBySidebarItem
          ),
          ...sidebarItems
        ]
      : sidebarItems;
  }
};

export default SBItemsHelper;
